// Answer feedback (the teaching moment): always fully opaque (no fade), tinted green / red, dark text on a light
// tint so it stays well above WCAG AA (green-950 on green-50, red-950 on red-50) in light and dark themes.
const BASE =
  "rounded-lg border px-3 py-2 text-sm leading-relaxed motion-safe:animate-in motion-safe:slide-in-from-bottom-1 motion-safe:duration-200";
export const feedbackBox = (right: boolean) =>
  `${BASE} ${
    right
      ? "border-green-700/50 bg-green-50 text-green-950 dark:border-green-500/50 dark:bg-green-950 dark:text-green-50"
      : "border-red-700/50 bg-red-50 text-red-950 dark:border-red-500/50 dark:bg-red-950 dark:text-red-50"
  }`;
export const feedbackTitle = (right: boolean) =>
  `flex items-center gap-1.5 text-base font-extrabold ${
    right
      ? "text-green-800 dark:text-green-300"
      : "text-red-800 dark:text-red-300"
  }`;
